import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import dayjs from 'dayjs';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { DIAGNOSIS_STEP_TYPES } from '@lean-body/src/domain/matching_assessment_diagnosis_steps';
import { DiagnosisWeightChart } from '../molecules/diagnosis_weight_chart';
import { DiagnosisHealthLevelCard } from '../molecules/diagnosis_health_level_card';
import { DiagnosisWorkoutLevelCard } from '../molecules/diagnosis_workout_level_card';
import { ArrowDirection, ArrowIconWithMargin } from '../atoms';
const TARGET_TIMEFRAME_LABEL_TO_GOAL_KEEP_VALUE = {
    '2週間後': '2週間',
    '1ヶ月後': '1ヶ月',
    '3ヶ月後': '3ヶ月',
    半年後: '半年',
    いつでもいい: '半年',
};
const USER_PRIMARY_GOAL_LABEL_TO_GOAL_KEEP_DESCRIPTION = {
    体重を落としたい: '体重を落とす',
    'お腹・見た目を変えたい': 'お腹・見た目を変える',
    間食や食欲をコントロールしたい: '間食や食欲をコントロールする',
    '体力・疲れやすさを改善したい': '体力・疲れやすさを改善する',
    健康診断の数値が気になる: '健康診断の数値を改善する',
};
const ACTIVE_LIFESTYLE_LABELS = ['できるだけ動くようにしている', '1日中よく動き回っている'];
export const MatchingAssessmentDiagnosisPlanAnalyzedResult = ({ userName, isWeightKeeping, currentWeight, weightGoal, goalDateUnix, diagnosisParams, }) => {
    var _a, _b, _c, _d;
    const goalDate = dayjs.unix(goalDateUnix);
    const lifestyleAnswer = diagnosisParams === null || diagnosisParams === void 0 ? void 0 : diagnosisParams.find((a) => a.stepType === DIAGNOSIS_STEP_TYPES.lifestyle_type);
    const targetTimeframeAnswer = diagnosisParams === null || diagnosisParams === void 0 ? void 0 : diagnosisParams.find((a) => a.stepType === DIAGNOSIS_STEP_TYPES.target_timeframe);
    const userPrimaryGoalAnswer = diagnosisParams === null || diagnosisParams === void 0 ? void 0 : diagnosisParams.find((a) => a.stepType === DIAGNOSIS_STEP_TYPES.user_primary_goal);
    const activeLifestyleLabels = new Set(ACTIVE_LIFESTYLE_LABELS);
    const isActiveLifestyle = (_b = (_a = lifestyleAnswer === null || lifestyleAnswer === void 0 ? void 0 : lifestyleAnswer.choiceLabels) === null || _a === void 0 ? void 0 : _a.some((label) => activeLifestyleLabels.has(label))) !== null && _b !== void 0 ? _b : false;
    const goalKeepValueText = TARGET_TIMEFRAME_LABEL_TO_GOAL_KEEP_VALUE[((_c = targetTimeframeAnswer === null || targetTimeframeAnswer === void 0 ? void 0 : targetTimeframeAnswer.choiceLabels) === null || _c === void 0 ? void 0 : _c[0]) || ''] || '2週間';
    const goalKeepDescriptionText = USER_PRIMARY_GOAL_LABEL_TO_GOAL_KEEP_DESCRIPTION[((_d = userPrimaryGoalAnswer === null || userPrimaryGoalAnswer === void 0 ? void 0 : userPrimaryGoalAnswer.choiceLabels) === null || _d === void 0 ? void 0 : _d[0]) || ''] ||
        '間食や食欲をコントロールする';
    return (React.createElement("div", { className: css(styles.innerWrapper) },
        React.createElement("img", { className: css(styles.checkIcon), src: "/assets/images/goal_matching_assessments/diagnosis_check.png", alt: "" }),
        React.createElement("div", { className: css(styles.titleText) },
            userName,
            "\u3055\u3093\u5C02\u7528\u306E\u30D7\u30E9\u30F3\u304C\u3067\u304D\u307E\u3057\u305F\uFF01"),
        React.createElement("div", { className: css(styles.goalContainer) },
            React.createElement("div", { className: css(styles.subtitleText) }, "\u56DE\u7B54\u3092\u5143\u306B\u8A2D\u5B9A\u3057\u305F\u76EE\u6A19\u306F\u3053\u3061\u3089"),
            isWeightKeeping ? (React.createElement("div", { className: css(styles.goalBox) },
                React.createElement("div", { className: css(styles.goalKeepRow) },
                    React.createElement("span", { className: css(styles.goalKeepLabel) }, "\u671F\u9593"),
                    React.createElement("span", { className: css(styles.goalKeepDivider) }, "|"),
                    React.createElement("span", { className: css(styles.goalKeepValue) }, goalKeepValueText)),
                React.createElement("div", { className: css(styles.goalKeepDescription) }, goalKeepDescriptionText))) : (React.createElement("div", { className: css(styles.goalBox, styles.goalBoxWithDate) },
                React.createElement("div", null,
                    React.createElement("span", { className: css(styles.goalDateText) }, goalDate.year()),
                    "\u5E74",
                    React.createElement("span", { className: css(styles.goalDateText) }, goalDate.month() + 1),
                    "\u6708",
                    React.createElement("span", { className: css(styles.goalDateText) }, goalDate.date()),
                    "\u65E5\u307E\u3067\u306B"),
                React.createElement("div", null,
                    React.createElement("span", { className: css(styles.goalWeightNumber) }, weightGoal),
                    "kg")))),
        React.createElement("div", { className: css(styles.goalImagination) },
            !isWeightKeeping && (React.createElement(DiagnosisWeightChart, { classObject: styles.chart, currentWeight: currentWeight, targetWeight: weightGoal, goalDate: goalDate })),
            React.createElement("div", { className: css(styles.levelComparisonSection) },
                React.createElement(DiagnosisHealthLevelCard, { rating: 2.5 }),
                React.createElement(ArrowIconWithMargin, { classObject: styles.levelArrow, direction: ArrowDirection.right, color: Colors.Accent }),
                React.createElement(DiagnosisHealthLevelCard, { rating: 5 })),
            React.createElement("div", { className: css(styles.levelComparisonSection, styles.levelComparisonSectionWitBottomText) },
                React.createElement(DiagnosisWorkoutLevelCard, { label: isActiveLifestyle ? '中級' : '初級', filledCount: isActiveLifestyle ? 2 : 1 }),
                React.createElement(ArrowIconWithMargin, { classObject: styles.levelArrow, direction: ArrowDirection.right, color: Colors.Accent }),
                React.createElement(DiagnosisWorkoutLevelCard, { label: isActiveLifestyle ? '上級' : '中級', filledCount: isActiveLifestyle ? 3 : 2 })),
            React.createElement("div", { className: css(styles.chartNote) }, "\u30B0\u30E9\u30D5\u306F\u30A4\u30E1\u30FC\u30B8\u3067\u3059\u3002")),
        React.createElement("div", { className: css(styles.motivationalText) },
            "\u5B8C\u74A7\u3092\u76EE\u6307\u3059\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
            React.createElement("br", null),
            "\u3067\u304D\u308B\u3068\u3053\u308D\u304B\u3089\u3001\u59CB\u3081\u307E\u3057\u3087\u3046 \uD83D\uDEA9")));
};
const styles = StyleSheet.create({
    innerWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
        [MediaBreakPointUp.MD]: {
            maxWidth: 375,
            margin: '0 auto',
        },
    },
    checkIcon: {
        width: 148,
        height: 46,
    },
    titleText: {
        fontSize: 16,
        fontWeight: 400,
        color: Colors.TextDark,
        textAlign: 'center',
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
    goalContainer: {
        width: '100%',
    },
    subtitleText: {
        fontSize: 14,
        fontWeight: 400,
        color: Colors.TextDark,
        textAlign: 'center',
        lineHeight: '140%',
        letterSpacing: 0.56,
        marginBottom: 8,
    },
    goalBox: {
        width: '100%',
        maxWidth: 327,
        backgroundColor: Colors.White,
        borderRadius: 14,
        padding: '10px 0px 16px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.Black,
        letterSpacing: 0.56,
        gap: 8,
    },
    goalBoxWithDate: {
        padding: '8px 0px 4px',
        gap: 0,
    },
    goalDateText: {
        fontSize: 20,
        letterSpacing: 0.8,
    },
    goalWeightNumber: {
        fontSize: 32,
        color: Colors.TextDark,
        letterSpacing: 1.28,
    },
    goalKeepRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 16px',
        borderRadius: 8,
        gap: 8,
        background: Colors.BackgroundGrayC,
    },
    goalKeepLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: Colors.GrayDarkest,
        lineHeight: '100%',
        letterSpacing: 0.56,
    },
    goalKeepDivider: {
        fontSize: 14,
        color: Colors.Gray,
        flex: 1,
    },
    goalKeepValue: {
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.Black,
        lineHeight: '100%',
        letterSpacing: 0.56,
    },
    goalKeepDescription: {
        fontSize: 15,
        fontWeight: 'bold',
        color: Colors.TextDark,
        letterSpacing: 0.6,
        textAlign: 'center',
    },
    goalImagination: {
        background: Colors.White,
        width: '100%',
    },
    chart: {
        borderBottom: `1px solid ${Colors.BorderLightGray}`,
    },
    chartNote: {
        fontSize: 10,
        color: Colors.TextDark,
        margin: '12px 32px 10px 0',
        textAlign: 'right',
    },
    levelComparisonSection: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 32px',
    },
    levelComparisonSectionWitBottomText: {
        paddingBottom: 0,
        borderTop: `1px solid ${Colors.BorderLightGray}`,
    },
    levelArrow: {
        width: 30,
        height: 30,
        flexShrink: 0,
        flex: 1,
    },
    motivationalText: {
        fontSize: 16,
        color: Colors.TextDark,
        lineHeight: '160%',
        textAlign: 'center',
        letterSpacing: 1.28,
    },
});
